import { ToasterMessage } from "@/entities/toaster-message";
import { useNotificationStore } from "@/stores/notification";

export default class NotificationMessageService {

  public static showError(text: string, values: any = null, duration?: number) {
    this.showMessage(text, "error", values, duration)
  }
  public static showInfo(text: string, values: any = null) {
    this.showMessage(text, "info", values)
  }
  public static showWarning(text: string, values: any = null) {
    this.showMessage(text, "warning", values)
  }
  public static showSuccess(text: string, values: any = null, duration?: number) {
    this.showMessage(text, "success", values, duration)
  }

  private static showMessage(text: string, type: any, values: any = null, duration?: number): void {
    const message: ToasterMessage = {
      message: text,
      type,
      values,
      duration
    }

    const notificationStore = useNotificationStore();

    notificationStore.addMessage(message);
  }
}
